import { ISPEnvironment } from './environment.interface';

export const environment = {
  production: true,
} as ISPEnvironment;
